import React from 'react';
import { TablePrice } from '../table-price';
import DescriptionPrice from '../description-price';
import classes from '../../price-breaks-popup.scss';
export const InfoPrice = () => /*#__PURE__*/React.createElement("div", {
  className: classes.popupContext
}, /*#__PURE__*/React.createElement(DescriptionPrice, null), /*#__PURE__*/React.createElement(TablePrice, null));